'use client';

import { DatadogProvider, withTimeout } from '@datadog/openfeature-browser';
import { OpenFeatureProvider } from '@openfeature/react-sdk';
import { OpenFeature } from '@openfeature/web-sdk';
import { type PropsWithChildren, useEffect } from 'react';

const FLAG_CONFIGURATION_TIMEOUT_MS = 5_000;

export default function DataDogFeatureFlagProvider({
  children,
}: PropsWithChildren) {
  useEffect(() => {
    const applicationId = process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID ?? '';
    const clientToken = process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN ?? '';
    const env = process.env.ENVIRONMENT ?? '';

    if (!applicationId || !clientToken || !env) return;

    OpenFeature.setProvider(
      new DatadogProvider({
        applicationId,
        clientToken,
        site: 'datadoghq.com',
        service: 'fastfive-consumer-web',
        env,
        version: process.env.NEXT_PUBLIC_DATADOG_VERSION,
        flagConfigurationFetch: withTimeout(
          globalThis.fetch,
          FLAG_CONFIGURATION_TIMEOUT_MS,
        ),
      }),
    );
  }, []);

  return <OpenFeatureProvider>{children}</OpenFeatureProvider>;
}
